import React from 'react';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';

import TariffCardWrapper from '~/src/components/LandingBlock/Tariffs/TariffCard';
import type { ITariffFull } from '~/src/services/tariffs/types';
import type { TCardButtonProps } from '~/src/components/LandingBlock/TariffCardsRA/CardRA';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

interface TariffsCarouselProps {
    tariffs: ITariffFull[];
    isFullByActive: boolean;
    buttonProps: TCardButtonProps;
    cityDomain: string;
    handleOpenModal: (tariff: ITariffFull) => void;
}

const TariffsCarousel = ({
  tariffs,
  isFullByActive,
  buttonProps,
  cityDomain,
  handleOpenModal,
}: TariffsCarouselProps): JSX.Element => {
  const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

  return (
    <NukaCarousel
        slideWidth={isMobile ? '288px' : '314px'}
        disableEdgeSwiping
        withoutArrows={isMobile}
        withoutDots={true}
        cellAlign='left'
        wrapAround
        easing='easeCubicOut'
        edgeEasing='easeCubicOut'
    >
      {tariffs.map(tariff => (
        <TariffCardWrapper
              key={tariff.productId}
              tariff={tariff}
              isFullByActive={isFullByActive}
              idForScroll={buttonProps.idForScroll}
              buttonProps={buttonProps}
              cityDomain={cityDomain}
              openModal={async () => handleOpenModal(tariff)}
          />
        ))}
    </NukaCarousel>
  );
};

export default TariffsCarousel;
